// extracted by mini-css-extract-plugin
export var standaloneTable = "_gm-0";
export var withExtraHeader = "_gm-1";